import { LoadableLazy } from '@confluence/loadable';
export { isEligibleForReleaseNotesDiscovery } from '../src/rovo/ReleaseNotesDialog';
export const LazyReleaseNotesPublishDiscoveryDialog = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReleaseNotesDialog" */ '../src/rovo/ReleaseNotesDialog'
			)
		).ReleaseNotesDialog,
});
